import Api from '@services/api';

export default {
  preapproveThread(inquiryId, origin) {
    return Api()
      .post(`/inquiry/${inquiryId}/preapprove`, null, {params: {origin}})
      .then((res) => res.data);
  },
  updateTimes(inquiryId, times) {
    return Api()
      .put(`/inquiry/${inquiryId}/times`, times)
      .then((res) => res.data);
  },
};
